import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sidebarIsOpen: false,
}

export const layoutSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarIsOpen = !state.sidebarIsOpen
    },
    openSidebar: (state) => {
      state.sidebarIsOpen = true
    },
  },
})

// Action creators are generated for each case reducer function
export const { toggleSidebar , openSidebar} = layoutSlice.actions

export default layoutSlice.reducer